import {RouteConfig} from 'vue-router';
import ProfileInfoConfig from '@/components/Profile/config/ProfileInfoConfig.vue';
import ProfileSkillsConfig from '@/components/Profile/config/ProfileSkillsConfig.vue';
import ProfilePlatformSettings from '@/components/Profile/config/ProfilePlatformSettings.vue';
import ProfileSecurityConfig from '@/components/Profile/config/ProfileSecurityConfig.vue';
import {authenticated} from '@/guards/auth.guard';

export const configRoutes: RouteConfig[] = [
    {
        path: ':slug',
        component: ProfileInfoConfig,
        beforeEnter: (to, from, next) => {
            if (to.params.slug === 'me') {
              if (authenticated()) {
                next()
              } else {
                next(from.path)
              }
            } else {
              next()
            }
        },
        children: [
            {
                path: '',
                name: 'ProfileInfoConfig',
                component: ProfileInfoConfig,
            },
            {
                path: 'skills',
                name: 'ProfileSkillsConfig',
                component: ProfileSkillsConfig,
            },
            {
                path: 'settings',
                name: 'ProfilePlatformSettings',
                component: ProfilePlatformSettings,
            },
            {
                path: 'security',
                name: 'ProfileSecurityConfig',
                component: ProfileSecurityConfig,
            }
        ]
    }
];